export const isInLocalDevelopmentMode = () =>
  ["localhost", "0.0.0.0"].indexOf(window.location.hostname) >= 0;
